import actionDispatcher from 'api/actionDispatcher';
import { refreshCompanyToken, fetchAdminInformationApi, logoutApi } from 'api/auth';

import actionType from './actionConstant';

export const refreshCompanyAction = ({ token, companyUUID }) =>
    actionDispatcher({
        serviceMethod: refreshCompanyToken.bind(null, { companyUUID, token }),
        actionTypeSuccess: actionType.AUTH.COMPANY.REFRESH.SUCCESS,
        actionTypeFailure: actionType.AUTH.COMPANY.REFRESH.FAILURE,
        actionTypeInProgress: actionType.AUTH.COMPANY.REFRESH.INPROGRESS,
        extra: null,
        commonConfig: { loader: false },
        callback: () => {},
    });

export const fetchAdminInformationAction = (
    token,
    commonConfig = { loader: false },
    cb = () => {}
) =>
    actionDispatcher({
        serviceMethod: fetchAdminInformationApi.bind(null, { token }),
        actionTypeSuccess: actionType.FETCH_ADMIN_INFORMATION_SUCCESS,
        actionTypeFailure: actionType.FETCH_ADMIN_INFORMATION_FAILURE,
        actionTypeInProgress: actionType.FETCH_ADMIN_INFORMATION_REQUEST,
        extra: null,
        commonConfig: commonConfig,
        callback: cb,
    });

export const logoutAction = (token, commonConfig = { loader: true }, cb = () => {}) =>
    actionDispatcher({
        serviceMethod: logoutApi.bind(null, { token }),
        actionTypeSuccess: actionType.RESET_ALL_REDUCERS,
        actionTypeFailure: actionType.LOGOUT_FAILURE,
        actionTypeInProgress: actionType.LOGOUT_REQUEST,
        extra: { token },
        commonConfig: commonConfig,
        callback: cb,
    });

// Reset the RTK Query caches (in-memory server cache) so a logout / company
// switch does not surface the previous company's data. The settings slice is
// cleared via RESET_ALL_REDUCERS; the API caches are cleared here.
export const resetApiCachesAction = () => (dispatch) => {
    dispatch({ type: 'base-api/resetApiState' });
    dispatch({ type: 'global-api/resetApiState' });
};

export const clearToken = () => {
    return {
        type: actionType.AUTH.CLEAR_TOKEN,
    };
};

export const loginAction = (data) => {
    return {
        type: actionType.LOGIN_SUCCESS,
        payload: data,
    };
};

export const updateCompanyEmailNotificationStatus = (status) => {
    return {
        type: actionType.UPDATE_COMPANY_EMAIL_NOTIFICATION_STATUS,
        payload: status === true ? 1 : 0,
    };
};
